export default {"src":"/_next/static/media/dynamics.5b58ae37.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};